module.exports = __webpack_public_path__ + "img/ucb-1.a5cc6bec.jpg";